<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      resizable
      border
      ref="xTable"
      :checkboxConfig="{
        highlight: false,
      }"
      :edit-config="{ trigger: 'click', mode: 'row' }"
    >
      >
      <template v-slot:opt="{ row }">
        <div>
          <el-button size="small" type="primary" @click="calculate(row)">
            {{ $l('INDEX.table_label_calculate') || '计算' }}
          </el-button>
        </div>
      </template>
      <template v-slot:del="{ row }">
        <el-button size="small" type="danger" @click="delRow(row)">
          {{ $l('INDEX.table_label_delete') || '删除' }}
        </el-button>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
// import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [EditLoading],
  props: {
    AX: { type: String, default: '0' },
    AM: { type: String, default: '0' },
    AH: { type: String, default: '0' },
    AW: { type: String, default: '0' },
    data: {
      type: Array,
      default: () => [],
    },
  },
  components: {},
  data() {
    return {
      tableColumns: tableColumns(this),
      tableHeight: 300,
      flag: false,
      formulaCopy: '',
      tableData: [],
    }
  },

  watch: {
    data: {
      handler(data) {
        if (!data) {
          return
        }
        this.tableData = this.data
      },
      immediate: true,
    },
  },

  methods: {
    delRow(row) {
      let index = this.$refs.xTable.getRowIndex(row)
      this.tableData.splice(index, 1)
    },
    // 新增公式
    addtableData(form) {
      this.flag = false
      for (var i = 0, len = this.tableData.length; i < len; i++) {
        if (
          this.tableData[i].columnNo === form.columnNo &&
          this.tableData[i].columnNameZh === form.columnNameZh
        ) {
          this.flag = true
          this.$message.warning(
            this.$l('form_label_repeat') || '公式列重复请检查后保存!'
          )
          return false
        }
      }
      if (!this.flag) {
        this.tableData.push(form)
      }
    },
    //解析每行的公式
    getEachLineData() {
      for (var i = 0, len = this.tableData.length; i < len; i++) {
        if (this.tableData[i].columnValue) {
          let columnDetail = ''
          columnDetail = this.tableData[i].columnValue
          columnDetail = columnDetail.replace(
            new RegExp('AX', 'g'),
            this.AX || '0'
          )
          columnDetail = columnDetail.replace(
            new RegExp('AM', 'g'),
            this.AM || '0'
          )
          columnDetail = columnDetail.replace(
            new RegExp('AH', 'g'),
            this.AH || '0'
          )
          columnDetail = columnDetail.replace(
            new RegExp('AW', 'g'),
            this.AW || '0'
          )
          this.tableData[i].columnValueDetail = columnDetail
        }
      }

      for (var a = 0, lena = this.tableData.length; a < lena; a++) {
        for (var b = 0, lenb = this.tableData.length; b < lenb; b++) {
          this.tableData[a].columnValueDetail = this.tableData[
            a
          ].columnValueDetail.replace(
            new RegExp(this.tableData[b].columnNo, 'g'),
            '(' + this.tableData[b].columnValueDetail + ')' || '0'
          )
        }
      }
    },
    //每行计算
    async calculate(row) {
      const { columnValue } = row
      if (!columnValue){
        this.$message.warning(
           '请编辑公式后重试'
        )
        return
      } 

      //解析每行的公式
      this.getEachLineData()

      var reg = /[\u4e00-\u9fa5a-z]/i
      if (reg.test(row.columnValueDetail)) {
        this.$message.warning(
          this.$l('INDEX.form_label_try_again') || '含有中文或英文,请重试'
        )
        return
      }
      this.loadingOpen()
      return await this.$api
        .masterFormulaCalculateApi({
          calculate: row.columnValueDetail,
        })
        .then((res) => {
          row.results = parseFloat(res.body).toFixed(6)
          this.$refs.xTable.reloadData(this.tableData)
          this.loadingClose()
          return row.results
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(
            this.$l('INDEX.form_label_calculation_failed') || '计算失败！'
          )
        })
    },
    //计算合计
    async addMaterial(material) {
      if(this.tableData.length === 0){
        this.$message.error(
            this.$l('INDEX.form_label_add_material_filling_error') ||
              '耗料（AF）填写不正确'
          )
          return
      }
      for (var i = 0, len = this.tableData.length; i < len; i++) {
        if (this.tableData[i].columnNo === material) {
          return await this.calculate(this.tableData[i])
        }
        if (i === len - 1) {
          this.$message.error(
            this.$l('INDEX.form_label_add_material_filling_error') ||
              '耗料（AF）填写不正确'
          )
          return
        }
      }
    },
    getData() {
      return this.tableData
    },
  },
}
</script>
